var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"content-home"},[_c('BannerHome'),_c('SectionNews'),_c('SectionSolutions'),_c('SectionUseds'),_c('SectionBlog',{attrs:{"limit":3}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }